import React, { Fragment } from "react";
import "../../styles/medicalExpertProfile.scss";
import CustomHelmet from "../reusable/Helmet";
import { FiMessageCircle } from "react-icons/fi";
import arjunRathoreChat from "../../images/arjunRathoreChat.png";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import betterHealth from "../../images/icons/betterHealth.png";
import heartProblem from "../../images/icons/heartProblem.png";
import stethoscope from "../../images/icons/stethoscope.png";
import personaliseStudy from "../../images/personalStudyContent.png";
import perfectPracticeContent from "../../images/practicalUnderStanding.png";
import revisionChecks from "../../images/revisionChecks.png";
import arjunFeatureList from "../../images/arjunFeatures.png";
import { GoPlus } from "react-icons/go";
import { homeBanner } from "../../assets/images";
import { useAuth } from "alpha-ui";
import GptLayout from "../gptLayout";

const AnitaProfile = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();

  const handleRedirectToChat = () => {
    if (auth?.user?._id) {
      navigate(`/chat?type=question&isRedirected=true`);
    } else {
      // navigate("/login", { state: `/chat?type=question&isRedirected=true` });
      window.location.href = `${process.env.REACT_APP_REDIRECT_LINK}/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
    }
  };

  return (
    <Fragment>
      <CustomHelmet
        title="Meet Ravinder Yadav: Your AI Military Doctor - SSB-GPT"
        description="Prepare effectively for your SSB/AFSB/NSB/ interview with SSB-GPT, a free self-preparation tool."
      />
      <GptLayout>
        <div className="container">
          <div className="medicalExpertProfile_main txt_color">
            <div className="hero_section">
              <div className="left_sec">
                <div className="heading_top">Your AI INET Mentor</div>
                <h1 className="main_heading">
                  Meet Anita Deshmukh
                  <span>Your AI INET Mentor</span>
                </h1>
                <p className="description">
                  Anita Deshmukh is an advanced AI-powered academic mentor built
                  to help aspirants excel in the INET Written Examination.
                  Developed using insights from experienced defence educators,
                  Anita provides expert guidance across English, General
                  Science, Reasoning, Mathematical Aptitude, and General
                  Knowledge. With her focus on conceptual clarity, smart
                  revision, and personalized preparation strategies, she ensures
                  you're fully prepared to clear the written stage of the INET
                  selection process.
                </p>
                <button className="talk_captain" onClick={handleRedirectToChat}>
                  <FiMessageCircle /> Talk to Anita Deshmukh
                </button>
              </div>
              <div className="right_sec">
                <div className="intro_modal_sec">
                  <div className="profile_pic">
                    <img src={homeBanner} alt="medicalModal" />
                  </div>
                  <div className="name_sec">
                    <div className="name">Anita Deshmukh</div>
                    <div className="desc">AI INET Mentor</div>
                  </div>
                </div>
                <div className="social_links">
                  <Link
                    to="https://www.facebook.com/profile.php?id=61568163640272"
                    title="Facebook"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                  <Link
                    to="https://x.com/AIRavinder"
                    title="Twitter"
                    target="_blank"
                  >
                    <FaXTwitter />
                  </Link>
                  <Link
                    to="https://www.youtube.com/@AIRavinderYadav"
                    title="Youtube"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                  <Link
                    to="https://www.instagram.com/aidoctorravinder/"
                    title="Instagram"
                    target="_blank"
                  >
                    <FaInstagram />
                  </Link>
                </div>
              </div>
            </div>

            <div className="effective_member">
              <h2 className="heading">
                Anita Deshmukh: YOUR AI CDS MENTOR, AS RELIABLE AS A{" "}
                <span> PERSONAL DEFENCE COACH!</span>
              </h2>
              <p className="desc">
                Advanced AI offers comprehensive subject-wise assessments,
                helping candidates prepare dynamically to meet the academic
                standards of the CDS exam.
              </p>
              <div className="ai_img">
                <img src={arjunRathoreChat} alt="arjunRathoreChat" />
              </div>
            </div>

            <div className="next_level_prep">
              <h2 className="heading">
                EXPERIENCE ELITE-LEVEL{" "}
                <span> CDS PREPARATION AND GUIDANCE TODAY.</span>
              </h2>
              <div className="group_task_strategy">
                <div className="left_sec">
                  <div className="top_heading">Core Expertise</div>
                  <h2 className="sec_heading">
                    Delivers Personalized Study Content{" "}
                    <img src={stethoscope} alt="stethoscope" />
                  </h2>
                  <p className="desc">
                    Arjun analyzes your performance to curate subject-wise
                    content tailored to your learning needs. It focuses on your
                    weak areas while reinforcing your strengths with targeted
                    practice. This personalized approach ensures efficient
                    preparation for every section of the CDS exam.
                  </p>
                  <button className="talk_btn" onClick={handleRedirectToChat}>
                    <GoPlus />
                    Talk You To Anita Deshmukh
                  </button>
                </div>
                <div className="right_sec">
                  <div className="img_sec">
                    <img src={personaliseStudy} alt="personaliseStudy" />
                  </div>
                </div>
              </div>

              <div className="core_expretise_sec">
                <div className="psychTestPrep">
                  <div className="top_heading">Core Expertise</div>
                  <h2 className="sec_heading">
                    Offers Interactive Simulations for Practical Understanding{" "}
                    <img src={betterHealth} alt="betterHealth" />{" "}
                  </h2>
                  <p className="desc">
                    Arjun uses AI-driven simulations to break down complex
                    topics into real-world scenarios. These interactive modules
                    help you grasp difficult concepts through visual and
                    hands-on learning methods.
                  </p>
                  <img
                    src={perfectPracticeContent}
                    alt="perfectPracticeContent"
                  />
                </div>
                <div className="interviewSkillsPersonality">
                  <div className="top_heading">Core Expertise</div>
                  <h2 className="sec_heading">
                    Smart Topic Sequencing with Mock Tests & Revision Checks{" "}
                    <img src={heartProblem} alt="heartProblem" />
                  </h2>
                  <p className="desc">
                    Arjun ensures you've mastered previous topics by conducting
                    quick mock tests and revision sessions.
                  </p>
                  <img src={revisionChecks} alt="revisionChecks" />
                </div>
              </div>

              <div className="militaryAwareness">
                <div className="right_sec">
                  <div className="img_sec">
                    <div className="circle_sec">
                      <div className="red"></div>
                      <div className="blue"></div>
                      <div className="yellow"></div>
                    </div>
                  </div>
                  <img src={arjunFeatureList} alt="arjunFeatureList" />
                </div>
                <div className="left_sec">
                  <div className="top_heading">Core Expertise</div>
                  <h2 className="sec_heading">
                    Why Captain Arjun is Your Ultimate CDS Exam Mentor
                  </h2>
                  <ul className="desc_list">
                    <li>
                      Provides personalized study content based on your
                      performance and learning needs.
                    </li>
                    <li>
                      Offers interactive simulations to help you understand
                      complex topics practically.
                    </li>
                    <li>
                      Conducts quick mock tests and revision before introducing
                      new topics for stronger retention.
                    </li>
                    <li>
                      Available 24/7 to support your CDS preparation anytime,
                      anywhere.
                    </li>
                  </ul>
                  <button className="talk_btn" onClick={handleRedirectToChat}>
                    <GoPlus />
                    Talk you to Anita Deshmukh
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GptLayout>
    </Fragment>
  );
};

export default AnitaProfile;
